/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        button: {
            primary: {
                default: {
                    background: {
                        value: "#282e37",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    background: {
                        value: "#464e53",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                active: {
                    background: {
                        value: "#121a26",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                disabled: {
                    background: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            secondary: {
                default: {
                    background: {
                        value: "#ffffff",
                        type: "color",
                    },
                    borderColor: {
                        value: "#282e37",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                hover: {
                    background: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    borderColor: {
                        value: "#282e37",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                active: {
                    background: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    borderColor: {
                        value: "#282e37",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    background: {
                        value: "#ffffff",
                        type: "color",
                    },
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            tertiary: {
                default: {
                    background: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                hover: {
                    background: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                active: {
                    background: {
                        value: "#dadada",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    background: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
            },
            destructive: {
                primary: {
                    default: {
                        background: {
                            value: "#921a1d",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    hover: {
                        background: {
                            value: "#d3222a",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    active: {
                        background: {
                            value: "#5f091d",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    disabled: {
                        background: {
                            value: "#921a1d80",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
                secondary: {
                    default: {
                        background: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#921a1d",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                        color: {
                            value: "#921a1d",
                            type: "color",
                        },
                    },
                    hover: {
                        background: {
                            value: "#f3f3f3",
                            type: "color",
                        },
                        borderColor: {
                            value: "#d3222a",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                        color: {
                            value: "#d3222a",
                            type: "color",
                        },
                    },
                    active: {
                        background: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        borderColor: {
                            value: "#5f091d",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                        color: {
                            value: "#5f091d",
                            type: "color",
                        },
                    },
                    disabled: {
                        background: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#921a1d80",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                        color: {
                            value: "#921a1d80",
                            type: "color",
                        },
                    },
                },
                tertiary: {
                    default: {
                        background: {
                            value: "#ffffff",
                            type: "color",
                        },
                        color: {
                            value: "#921a1d",
                            type: "color",
                        },
                    },
                    hover: {
                        background: {
                            value: "#f3f3f3",
                            type: "color",
                        },
                        color: {
                            value: "#d3222a",
                            type: "color",
                        },
                    },
                    active: {
                        background: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        color: {
                            value: "#5f091d",
                            type: "color",
                        },
                    },
                    disabled: {
                        background: {
                            value: "#ffffff",
                            type: "color",
                        },
                        color: {
                            value: "#921a1d80",
                            type: "color",
                        },
                    },
                },
            },
            small: {
                height: {
                    value: "32px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "10px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "16px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "4px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "4px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
            medium: {
                height: {
                    value: "40px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "12px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "16px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "8px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
            large: {
                height: {
                    value: "48px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "12px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "16px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "8px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
            withLeadingIcon: {
                paddingLeft: {
                    value: "12px",
                    type: "dimension",
                },
                icon: {
                    marginRight: {
                        value: "4px",
                        type: "dimension",
                    },
                },
            },
            withTrailingIcon: {
                paddingRight: {
                    value: "12px",
                    type: "dimension",
                },
                icon: {
                    marginLeft: {
                        value: "4px",
                        type: "dimension",
                    },
                },
            },
            iconOnly: {
                small: {
                    width: {
                        value: "32px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "4px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                medium: {
                    width: {
                        value: "40px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                },
                large: {
                    width: {
                        value: "48px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
